/**
 * `components.MuiFormLabel` — hide required asterisk, outlined label background when shrunk.
 * Discoverability: `MuiFormLabel`, `FormLabel`, `InputLabel`, `asterisk`.
 *
 * @see https://mui.com/material-ui/api/form-label/
 *
 */
import type { Components, Theme } from '@mui/material/styles';

export function muiFormLabel(_theme: Theme): Pick<Components<Theme>, 'MuiFormLabel'> {
  return {
    MuiFormLabel: {
      styleOverrides: {
        asterisk: {
          display: 'none',
        },
      },
    },
  };
}
